import PaymentSettings from './PaymentSettings.page';

export default PaymentSettings;